import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {confirmAlert} from 'react-confirm-alert';
import {BeatLoader} from 'react-spinners';
import "../assets/css/monthpicker/month-picker.css";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import { List } from 'react-virtualized';
import ModalD from "react-awesome-modal";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Switch from "react-switch";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var monthOptions = [];
var monthOptions_task = [];
for(var i=0; i<=23; i++){
    let date2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    //console.log("currDate"); console.log(date2);
    let monthd = date2.setMonth(date2.getMonth() -i);
    date2 = date2.toDateString();
    date2 = new Date(date2);
    let month2 = getMonth(date2);
    let year2 = date2.getFullYear();
    let monthName2 = monthNames[date2.getMonth()];
    var isDisable = true;
    if(month2 == '06' || month2 == '07'){
        isDisable = false;
    }
    monthOptions.push({ value: month2+'_'+year2, label: monthName2+' '+year2});
    if(i>=12) {
        monthOptions_task.push({ value: month2+year2, label: monthName2+' '+year2})
    }

}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var tod1 = moment(todayDate).format('MM/DD/YYYY');
var yest1 = moment(yesterday).format('MM/DD/YYYY');
var todShow1 = moment(todayDate).format('D MMM YYYY');
var yestShow1 = moment(yesterday).format('D MMM YYYY');
var todSend1 = moment(todayDate).format('YYYY-MM-DD');
var yestSend1 = moment(yesterday).format('YYYY-MM-DD');


var date_limit = moment(todayDate).format('MM/DD/YYYY');
class JobMgt extends Component{
    constructor(props) {
        super(props);
        this.state = {
            feq_name_list:[],
            frequencyValue:{value:'', label: 'All'},
            frequency_id:'',
            task_data:[],
            taskName:'',
            newJobModel: false,
            loading:true,
            freqValue:{value:'', label: 'Select'},
            freq_id:'',
            feq_id:'',
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            dateTo1:tod,
            dateToShow1:todShow,
            todSend1:todSend,
            yestSend1:yestSend,
            datefrom1:yest,
            datefromShow1:yestShow,
            task_identifier: '',
            force_run: 0,
            error_data: [],
            etype: '',
            statusList:[{value:'', label: 'All'},{value:'success', label: 'Success'},{value:'failed', label: 'Failed'},{value:'running', label: 'Running'},{value:'pending', label: 'Pending'},{value:'stopped', label: 'Stopped'}],
            statusValue:{value:'', label: 'All'},
            selected_status:'',
            action_type:"",
            recipients:[{email:"", email_type:"Internal", receiver_type:"to", email_notification_id:"", task_schedule_id:""}],
            email_task: 'false',
            same_time_run: 'false',
            task_dep_list:[],
            task_dep_name:[],
            task_dep_value:'',
            job_status: false,
            send_task_status: 'false',
            isDisableInput: false,
            send_mail_to_business_team:'false'
        };

    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var isDisableInput = false;
        if(decoded.userSubGroup===5 && decoded.userSubGroupName==='IT'){
            isDisableInput= true
        }
        this.setState({
            email:decoded.email,
            userSubGroup: decoded.userSubGroup,
            userSubGroupName: decoded.userSubGroupName,
            isDisableInput: isDisableInput
        });
        this.get_frequency();
        this.get_task_dependencies();

        this.get_task_schedule(this.state.frequency_id, this.state.selected_status, decoded.userSubGroup, decoded.userSubGroupName);
    }

    handleClickDelete(idx,id) {
        this.setState({
            recipients: this.state.recipients.filter((s, sidx) => idx !== sidx)
        });

        axios.post(config.get('API_URL')+'/schedulereport/delete-email-notification/',{
            email_notification_id: id
        },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

            }).then(response => {



        }).catch( err => {
            console.log(err);
        });

    }
    get_task_dependencies(){
        axios.get(config.get('API_URL')+'/schedulereport/task_dependencies/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            response.data.data.map((dep,index) => {
                this.state.task_dep_list.push({value: dep.task_identifier, label: dep.task_identifier})
            });

        }).catch( err => {
            console.log(err);
        });
    }
      changeTaskDependancy(optionSelected){
        let value='';
        let depArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((dep, i) => {
                depArray.push(dep.value)
            });
        }

        this.setState({
            task_dep_value: optionSelected,
            task_dep_name: depArray
        });


    }
    toggleNewJobModel(modal_type) {
        //this.clearForm();
        this.setState({
             newJobModel: !this.state.newJobModel,
             action_type: 'Schedule New Script',
        })
    }
    addJob(){
        if(this.state.freq_id===''){
            this.props.handleClick("tr", 3, "Please Select Frequency");
            return false;
        } else if(this.state.taskName===''){
            this.props.handleClick("tr", 3, "Please Enter Task Name");
            return false;
        }
        else if(this.state.task_identifier===''){
            this.props.handleClick("tr", 3, "Please Enter Task Identifier");
            return false;
        }
        if(this.state.email_task==='true' || this.state.email_task===true) {
            let is_empty = 0;
            this.state.recipients.map((val,index) => {
                if(val.email===""){
                    is_empty = 1;
                }
            })
            if(is_empty===1){
                this.props.handleClick("tr", 3, "Email field is empty");
                return false;
            }
        }
        axios.post(config.get('API_URL')+'/schedulereport/schedule-new-script/',{
            task_name: this.state.taskName,
            task_identifier: this.state.task_identifier,
            task_dependencies: this.state.task_dep_name,
            run_at: this.state.run_at,
            last_run_status: this.state.last_run_status,
            comment: this.state.comment,
            script_name: this.state.script_name,
            email_task: this.state.email_task,
            run_status: this.state.job_status,
            task_frequency_id: this.state.freq_id,
            user_email: this.state.email,
            scheduled_by: this.state.email,
            same_time_run: this.state.same_time_run,
            recipients: this.state.recipients,
            send_task_status: this.state.send_task_status,
            send_mail_to_business_team: this.state.send_mail_to_business_team
        },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

            }).then(response => {
                this.props.handleClick("tr", 3, response.data);
                this.get_task_schedule(this.state.frequency_id, this.state.selected_status, this.state.userSubGroup, this.state.userSubGroupName);
                this.clearForm();


        }).catch( err => {
            console.log(err);
        });
        this.setState({
            newJobModel: false
        })
    }
    updateJob(){
        if(this.state.freq_id===''){
            this.props.handleClick("tr", 3, "Please Select Frequency");
            return false;
        } else if(this.state.taskName===''){
            this.props.handleClick("tr", 3, "Please Enter Task Name");
            return false;
        }
        else if(this.state.task_identifier===''){
            this.props.handleClick("tr", 3, "Please Enter Task Identifier");
            return false;
        }
        if(this.state.email_task==='true' || this.state.email_task===true) {
            let is_empty = 0;
            this.state.recipients.map((val,index) => {
                if(val.email===""){
                    is_empty = 1;
                }
            })
            if(is_empty===1){
                this.props.handleClick("tr", 3, "Email field is empty");
                return false;
            }
        }
        var data = {
            task_schedule_id: this.state.task_schedule_id,
            task_name: this.state.taskName,
            task_identifier: this.state.task_identifier,
            task_dependencies: this.state.task_dep_name,
            run_at: this.state.run_at,
            last_run_status: this.state.last_run_status,
            comment: this.state.comment,
            script_name: this.state.script_name,
            email_task: this.state.email_task,
            run_status: this.state.job_status,
            task_frequency_id: this.state.freq_id,
            user_email: this.state.email,
            scheduled_by: this.state.email,
            same_time_run: this.state.same_time_run,
            recipients: this.state.recipients,
            send_task_status: this.state.send_task_status,
            send_mail_to_business_team: this.state.send_mail_to_business_team
        }
        //console.log(data);
        //return false;
        axios.post(config.get('API_URL')+'/schedulereport/edit-job-script/',data,
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

            }).then(response => {
                this.props.handleClick("tr", 3, response.data);
                this.get_task_schedule(this.state.frequency_id, this.state.selected_status, this.state.userSubGroup, this.state.userSubGroupName);
                this.clearForm();

            }).catch( err => {
                console.log("err", err);
            });
            this.setState({
                newJobModel: false
            })
    }
    clearForm(){
        this.setState({
            taskName:'',
            task_identifier:'',
            recipients:[{email:"", email_type:"Internal", receiver_type:"to", email_notification_id:"", task_schedule_id:""}],
            email_task: 'false',
            same_time_run: 'false',
            send_task_status: 'false',
            task_dep_name:[],
            task_dep_value:'',
            job_status: false,
            freqValue:{value:'', label: 'Select'},
            freq_id:'',
            run_at:'',
            comment:''
        })
    }

    changeAct(obj) {

        this.setState({ job_status: obj });
    }
    editJob(task_schedule_id,task_frequency_id,task_name,arguments1,task_identifier,run_status,task_dependencies,
         comments, run_at, same_time_run, last_run_status,script_name, email_task,email_data,send_task_status,send_mail_to_business_team) {
         //console.log("lll",email_data.length);

         if(email_data.length<1){
            email_data = [{email:"", email_type:"Internal", receiver_type:"to", email_notification_id:"", task_schedule_id:""}];
         }
         this.get_frequency_name(task_frequency_id,'edit')
         var task_dep_value = [];
         task_dependencies.map((val,index) => {
             task_dep_value.push({value: val, label: val})
         });

        this.setState({
             task_schedule_id: task_schedule_id,
             freq_id: task_frequency_id,
             taskName:task_name,
             send_task_status:  send_task_status===null?'false':send_task_status.toString(),
             task_identifier:task_identifier,
             job_status: run_status==='active'?true:false,
             task_dep_value: task_dep_value,
             comment: comments,
             run_at: run_at===null?'':JSON.stringify(run_at),
             same_time_run: same_time_run===null?'false':same_time_run.toString(),
             last_run_status: last_run_status,
             script_name:script_name,
             email_task: email_task===null?'false':email_task.toString(),
             recipients: email_data,
             newJobModel: !this.state.newJobModel,
             action_type: 'Edit Script',
             send_mail_to_business_team:send_mail_to_business_team===null?'false':send_mail_to_business_team.toString(),

        })
    }
    get_task_schedule(frequency_id, status, userSubGroup, userSubGroupName) {
        this.setState({
            loading: true
        });
        if ($.fn.DataTable.isDataTable('#JobTable')) {
            $('#JobTable').DataTable().destroy();
        }
        // const fields = month.split('_');
        // const monthval = fields[0];
        // const yearval = fields[1];
         axios.post(config.get('API_URL')+'/schedulereport/get-all-job-script/',{
            userSubGroup:userSubGroup,
            userSubGroupName:userSubGroupName
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
             var tdata =  [];
             if (Array.isArray(response.data) && response.data.length) {
                 tdata = response.data;

                 this.setState({
                     task_data: tdata,
                     loading:false
                 });
             } else {

             tdata = response.data;
                 this.setState({
                     task_data: tdata,
                     loading:false
                 })
             }
             $('#JobTable').DataTable();

        }).catch( err => {
            console.log(err);
        });
    }


    get_frequency(val){
        axios.get(config.get('API_URL')+'/invoice/get_frequency_name/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
        //console.log(response);
            response.data.map((frequency,index) => {
                this.state.feq_name_list.push({value: frequency.task_frequency_id, label: frequency.frequency_name})
            });

        }).catch( err => {
            console.log(err);
        });
    }
    get_frequency_name(val, type){
        axios.get(config.get('API_URL')+'/schedulereport/get_frequency_name_by_id/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                frequency_id:val
            }
        }).then(response => {
        if(type==='add'){
            this.setState({
                run_at: response.data.default_run_at===null?'':JSON.stringify(response.data.default_run_at)
            })
        } else {
            this.setState({
                freqValue: {label:response.data.frequency_name, value:response.data.task_frequency_id}
            })
        }
        }).catch( err => {
            console.log(err);
        });
    }


    changeFrequency(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
       // alert(value);
        this.setState({
            frequency_id: value
        });

        this.get_task_schedule(value, this.state.selected_status,this.state.userSubGroup, this.state.userSubGroupName);
    }
    changeFrequency1(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
       // alert(value);
        this.setState({
            freq_id: value,
            freqValue: optionSelected
        });
        this.get_frequency_name(value,'add')
    }
    changeStatus(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
       // alert(value);
        this.setState({
            statusValue: optionSelected,
            selected_status: value
        });

        this.get_task_schedule(this.state.frequency_id,value,this.state.userSubGroup, this.state.userSubGroupName);
    }

    onChangeInput(e){
        this.setState({ [e.target.name]: e.target.value });
    }
    onRunChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    };
    changeLastRunStatus(e){
       this.setState({ [e.target.name]: e.target.value });
    }
    handleRemoveMinKey(idx, id, e) {
        e.preventDefault();
        console.log(id);
        console.log(idx);
        confirmAlert({
            title: 'Question',
            message: 'Are you sure want to delete.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickDelete(idx,id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
//         this.setState({
//             recipients: this.state.recipients.filter((s, sidx) => idx !== sidx)
//         });
    }
    handleAddMinKey(idx, arrayLenght, e) {
        e.preventDefault();
        var obLabel = (arrayLenght+10).toString(36);
        this.setState({
            recipients: this.state.recipients.concat([{email:"", email_type:"Internal", receiver_type:"to",email_notification_id:"", task_schedule_id:""}])
        });
        //this.get_object_stage(1,1)
    }
    changeEmail(idx, e){
        const pemail = this.state.recipients.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, email: e.target.value };
        });
        this.setState({ recipients: pemail });
    }
    changeEmailType(idx, e){
        const pemail_type = this.state.recipients.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, email_type: e.target.value };
        });
        this.setState({ recipients: pemail_type });
    }
    changeReceiverType(idx, e){
        const pReceiverType = this.state.recipients.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, receiver_type: e.target.value };
        });
        this.setState({ recipients: pReceiverType });
    }
    render() {
        const condition = true;
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "34px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "34px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 }),

        };

        let jobTableData = this.state.task_data.map((val,index) => {
            return (
                <tr key={index + 1}>
                    <td>{val["task_name"]}</td>
                    <td>{val["comments"]}</td>
                    <td>{val["last_system_run_start_time"]=='' || val["last_system_run_start_time"]==null?'':moment(val["last_system_run_start_time"]).format('D MMM YYYY HH:mm:ss')}</td>
                    <td>{val["last_run_status"]}</td>
                    <td className="text-center">
                       <a href="#" data-tip="Edit" className="btn btn-default actionBtn btn-edit" role="button"
                           onClick={this.editJob.bind(this, val.task_schedule_id, val.task_frequency_id,
                           val.task_name, val.arguments, val.task_identifier, val.run_status, val.task_dependencies,
                           val.comments, val.run_at, val.same_time_run, val.last_run_status,
                           val.script_name, val.email_task,val.emailData, val.send_task_status,val.send_mail_to_business_team)}><span
                            className="glyphicon glyphicon-edit" aria-hidden="true"></span></a>
                    </td>

                </tr>
            )
        });
        return(


            <div className="content">
                <style>
                    {`
                    .css-1r4vtzz {
                      background: ${this.state.isDisableInput ? '#f5f5f5' : ''};
                      cursor: ${this.state.isDisableInput ? 'not-allowed' : ''};
                    }
                  ` }
                </style>
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-12 pt-5">
                        <NotificationSystem ref="notificationSystem" style={style} />
                            <div className="card">

{/*                                 <div className="content"> */}
{/*                                     <div className="row"> */}
{/*                                         <NotificationSystem ref="notificationSystem" style={style} /> */}
{/*                                         <div className="col-md-12"> */}
{/*                                             <div className="col-md-3 "> */}
{/*                                                 <label> Frequency </label> */}
{/*                                                 <Select name="Frequency" */}
{/*                                                         value={this.state.frequencyValue} */}
{/*                                                         styles={customStyles} className="chainLists" */}
{/*                                                         isClearable={false} */}
{/*                                                         onChange={this.changeFrequency.bind(this)} */}
{/*                                                         options={this.state.feq_name_list} */}

{/*                                                         placeholder="Frequency" */}

{/*                                                 /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}
{/*                                             <div className="col-md-3 "> */}
{/*                                                 <label> Status </label> */}
{/*                                                 <Select name="status" */}
{/*                                                         value={this.state.statusValue} */}
{/*                                                         styles={customStyles} className="chainLists" */}
{/*                                                         isClearable={false} */}
{/*                                                         onChange={this.changeStatus.bind(this)} */}
{/*                                                         options={this.state.statusList} */}
{/*                                                         defaultValue={{ label: "All", value: '' }} */}
{/*                                                         //placeholder="Status" */}
{/*                                                 /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}

{/*                                         </div> */}
{/*                                     </div> */}
{/*                                 </div> */}
{/*                                 <hr className="m-0 p-0"/> */}
                                <div className="content table-full-width table-responsive nomargin">
                                    <div className="col-md-8">
                                        <div className="">
                                            <h4 className="title">Jobs/Process Management</h4>
                                        </div>
                                    </div>
                                    { this.state.userSubGroup!==5 && this.state.userSubGroupName!=='IT'?
                                    <div className="col-md-4 pull-right" style={{textAlign:'right'}}>
                                        <a href="#" className="addButton" role="button"
                                           onClick={this.toggleNewJobModel.bind(this, 'Add')}><span
                                            className="glyphicon glyphicon-plus" aria-hidden="true"></span>Schedule New Job Script</a>
                                    </div>:null}
                                    <table id="JobTable" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th>Script Name</th>
                                            <th>Comments</th>
                                            <th>Last system run start time</th>
                                            <th>Last Run Status</th>
                                            <th className="text-center">Action</th>

                                        </tr>
                                        </thead>
                                        <tbody>

                                        {jobTableData}
                                        </tbody>

                                    </table>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />

                                <Modal isOpen={this.state.newJobModel} toggle={this.toggleNewJobModel.bind(this)}>
                                <ModalHeader toggle={this.toggleNewJobModel.bind(this)}>{this.state.action_type}</ModalHeader>
                                <ModalBody className="user_form_fields">
                                  
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                               <label> Frequency </label>
                                                <Select name="Frequency"
                                                        value={this.state.freqValue}
                                                        styles={customStyles} className="chainLists"
                                                        isClearable={false}
                                                        onChange={this.changeFrequency1.bind(this)}
                                                        options={this.state.feq_name_list}
                                                        isDisabled={this.state.isDisableInput}
                                                        placeholder="Frequency"
                                                />
                                                
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="taskName">Task Name</Label>
                                                <Input id="taskName" name="taskName" value={this.state.taskName}
                                                       onChange={this.onChangeInput.bind(this)} disabled={this.state.isDisableInput}/>
                                               
                                            </FormGroup>
                                        </div>
                                    </div>

                                    {this.state.isDisableInput===false?
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                        <FormGroup>
                                                <Label for="startDate">Task Identifier</Label>
                                                <Input id="task_identifier" name="task_identifier" value={this.state.task_identifier}
                                                       onChange={this.onChangeInput.bind(this)} disabled={this.state.isDisableInput} />
                                               
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="task_dependencies">Task dependencies</Label>
                                                <ReactMultiSelectCheckboxes name="gst"
                                                    value={this.state.task_dep_value}
                                                    styles={customStyles} className="partyNameList"
                                                    isClearable={false}
                                                    onChange={this.changeTaskDependancy.bind(this)}
                                                    options={this.state.task_dep_list}
                                                    isDisabled={this.state.isDisableInput}
                                                    placeholderButtonLabel="All"
                                                    // placeholder="All"
                                                />


                                                {/*{this.validator.message('phone', this.state.phone, 'required|phone')}*/}
                                            </FormGroup>
                                        </div>
                                    </div>:null}

                                         <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                        <FormGroup>
                                                <Label for="startDate">Run at</Label>
                                                <Input id="run_at" name="run_at" value={this.state.run_at}
                                                       onChange={this.onChangeInput.bind(this)} disabled={this.state.isDisableInput}/>

                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="last_run_status">Last Run Status</Label>
                                                <select name="last_run_status" className="form-control"
                                                            value={this.state.last_run_status}
                                                            onChange={this.changeLastRunStatus.bind(this)}
                                                    disabled={this.state.isDisableInput} >
                                                        <option value="">Select</option>
                                                        <option value="success">Success</option>
                                                        <option value="running">Running</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="failed">Failed</option>
                                                        <option value="stopped">Stopped</option>
                                                    </select>
                                            </FormGroup>
                                        </div>
                                    </div>

                                    <div className="row">
                                    {this.state.isDisableInput===false?
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="comment">Comment</Label>
                                                <textarea name = "comment" rows="3" placeholder="" id="formControlsTextarea" onChange={this.onChangeInput.bind(this)}
                                                      className="form-control pricingDescription" value={this.state.comment} disabled={this.state.isDisableInput}></textarea>
                                            </FormGroup>
                                        </div>:null}
                                        <div className="col-md-6 col-sm-12">
                                        {this.state.isDisableInput===false?
                                            <div>
                                            <FormGroup>
                                                <Label for="same_time_run">Same Time Run</Label>
                                                &nbsp;&nbsp;<input type="radio" name="same_time_run"
                                                                   value="true"
                                                                   checked={this.state.same_time_run === 'true'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput}/> &nbsp; True
                                                &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="same_time_run"
                                                                   value="false"
                                                                   checked={this.state.same_time_run === 'false'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput}/> &nbsp; False
                                            </FormGroup>

                                           <FormGroup>
                                                <Label for="send_task_status">Is Send task status</Label>

                                                &nbsp;&nbsp;<input type="radio" name="send_task_status"
                                                                   value="true"
                                                                   checked={this.state.send_task_status === 'true'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput}/> &nbsp; True
                                                &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="send_task_status"
                                                                   value="false"
                                                                   checked={this.state.send_task_status === 'false'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput}/> &nbsp; False
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;


                                           </FormGroup>
                                           <FormGroup>
                                                <Label for="send_mail_to_business_team">Is Send mail to business team</Label>

                                                &nbsp;&nbsp;<input type="radio" name="send_mail_to_business_team"
                                                                   value="true"
                                                                   checked={this.state.send_mail_to_business_team === 'true'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput}/> &nbsp; True
                                                &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="send_mail_to_business_team"
                                                                   value="false"
                                                                   checked={this.state.send_mail_to_business_team === 'false'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput}/> &nbsp; False
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;


                                           </FormGroup> </div>:null}
                                           <FormGroup>
                                                <Label for="email_task">Is Email Task</Label>

                                                &nbsp;&nbsp;<input type="radio" name="email_task"
                                                                   value="true"
                                                                   checked={this.state.email_task === 'true'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput} /> &nbsp; True
                                                &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="email_task"
                                                                   value="false"
                                                                   checked={this.state.email_task === 'false'}
                                                                   onChange={this.onRunChanged} disabled={this.state.isDisableInput} /> &nbsp; False
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                   <Label for="status">Status</Label>&nbsp;&nbsp;
                                                <Switch className="react-switch" height={18} width={38} onChange={this.changeAct.bind(this)} checked={(this.state.job_status)? true : false} />

                                           </FormGroup>
                                        </div>
                                    </div>
                                    {this.state.email_task =='true'?
                                    <div className="">
                                        {this.state.recipients.map((recipients, idx) => (
                                            <div className="recipients-container" key={idx+1}>
                                                {/*<div>*/}
                                                <div className="col-md-1 padd-2">
                                                    {idx==0?<div className=""><label>&nbsp;</label></div>:null}
                                                    <div className="Rule-al">
                                                        {idx>0?
                                                            <a href="#" onClick={this.handleRemoveMinKey.bind(this,idx,recipients.email_notification_id)}
                                                               className="addmore_rulesp"
                                                            ><i className="fa fa-trash" aria-hidden="true"></i>
                                                            </a>:<a href="#" onClick={this.handleAddMinKey.bind(this, idx+1, this.state.recipients.length)}
                                                                    className="addmore_rulesp-plus"
                                                            ><span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                            </a>}

                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    {idx==0?<label> Email </label>:null}
                                                    {/*<Input id="email" name="email"  />*/}
                                                    <input type="text" value={recipients.email} name="email" className="form-control" onChange={this.changeEmail.bind(this, idx)}/>
                                                    <div className="clearfix"></div>

                                                </div>
                                                <div className="col-md-3">
                                                    {idx==0?<label> Email Type </label>:null}
                                                    <select name="email_type"
                                                            className="form-control"
                                                            value={recipients.email_type}
                                                            onChange={this.changeEmailType.bind(this, idx)}>
                                                        <option value="Internal">Internal</option>
                                                        <option value="External">External</option>

                                                    </select>

                                                    <div className="clearfix"></div>

                                                </div>
                                                <div className="col-md-3">
                                                    {idx==0?<label> Receiver Type </label>:null}
                                                    <select name="receiver_type"
                                                            className="form-control"
                                                            value={recipients.receiver_type}
                                                            onChange={this.changeReceiverType.bind(this, idx)}>
                                                        <option value="to">to</option>
                                                        <option value="cc">cc</option>
                                                        <option value="bcc">bcc</option>
                                                    </select>

                                                    <div className="clearfix"></div>

                                                </div>
                                                <div className="clearfix"></div>
                                            </div>))}
                                    </div>:null}
                                </ModalBody>
                                <ModalFooter>

                                    <div className="col-md-6 pull-right">
                                        {this.state.action_type == 'Schedule New Script'?
                                            <Button color="primary" onClick={this.addJob.bind(this)}>Submit</Button>
                                            : null }
                                        {this.state.action_type == 'Edit Script'?
                                            <React.Fragment>
                                            <Button color="primary" onClick={this.updateJob.bind(this,'')}>Edit</Button>&nbsp;&nbsp;
                                            </React.Fragment>
                                            : null }

                                        <Button color="secondary"
                                                onClick={this.toggleNewJobModel.bind(this)}>Cancel</Button>
                                    </div>
                                </ModalFooter>
                            </Modal>
                                </div>
                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default JobMgt